"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortByField = exports.replaceAndTrim = exports.parseTime = exports.parseMediaType = exports.padLeft = exports.getSpeakerColor = exports.getFieldAndOrder = exports.getClearWordFromTranscript = void 0;

var parseTime = function parseTime(seconds) {
  var hours = "" + Math.floor(seconds / 3600);
  var minutes = "" + Math.floor(seconds % 3600 / 60);

  var _seconds = "" + Math.floor(seconds % 3600 % 60);

  return padLeft(hours, 2) + ":" + padLeft(minutes, 2) + ":" + padLeft(_seconds, 2);
};

exports.parseTime = parseTime;

var padLeft = function padLeft(string, total) {
  if (typeof string !== 'string') {
    throw new Error('First parameter must be a string');
  }

  if (typeof total !== 'number') {
    throw new Error('Second parameter must be a integer');
  }

  return new Array(total - string.length + 1).join('0') + string;
};

exports.padLeft = padLeft;

var replaceAndTrim = function replaceAndTrim(word) {
  return word.replace(/<br\s*[/]?>/gi, '').replace(/\n/gi, '').trim();
};

exports.replaceAndTrim = replaceAndTrim;

var getClearWordFromTranscript = function getClearWordFromTranscript(word) {
  // Wat??? If anyone figures out what the point of this replace is, can you please
  // add a note for future developers
  return replaceAndTrim(word).replace(/:$/, '');
}; // This method will always return the same color for a given speaker name.


exports.getClearWordFromTranscript = getClearWordFromTranscript;

var getSpeakerColor = function getSpeakerColor(speakerName) {
  var returnValue = ( // Get the product of the binary values of the first three characters
  // of the speaker name. (Watch out for shorter speaker names...)
  speakerName.charCodeAt(0) * (speakerName.charCodeAt(1) || 1) * (speakerName.charCodeAt(2) || 1) // Then get the modulus of 4095 (or the remainder of #fff)
  % 4095 // And convert to a hex representation.
  ).toString(16);
  return "#" + returnValue;
};

exports.getSpeakerColor = getSpeakerColor;

var sortByField = function sortByField(fieldName) {
  var _getFieldAndOrder = getFieldAndOrder(fieldName),
      sortOrder = _getFieldAndOrder.sortOrder,
      field = _getFieldAndOrder.field;

  return function (a, b) {
    var result = a[field] < b[field] ? -1 : a[field] > b[field] ? 1 : 0;
    return result * sortOrder;
  };
};

exports.sortByField = sortByField;

var getFieldAndOrder = function getFieldAndOrder(field) {
  var sortOrder = 1;

  if (field[0] === '-') {
    sortOrder = -1;
    field = field.substr(1);
  }

  return {
    sortOrder: sortOrder,
    field: field
  };
};

exports.getFieldAndOrder = getFieldAndOrder;

var parseMediaType = function parseMediaType(type) {
  if (type.indexOf('audio') > -1) {
    return 'audio';
  } else if (type.indexOf('video') > -1) {
    return 'video';
  } else return type;
};

exports.parseMediaType = parseMediaType;